import { render, staticRenderFns } from "./BeLoading.vue?vue&type=template&id=b451beb4&"
import script from "./BeLoading.js?vue&type=script&lang=js&"
export * from "./BeLoading.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports